module.exports = __webpack_public_path__ + "img/PL00256.b945d335.png";